import React from 'react';
import './MaintainanceScreen.css';
import StarField from './Mars/components/StarField';

const MaintainanceScreen = ({ redirectUrl }) => {
  return (
    <div className="maintenance-container">
      <StarField speedFactor={0.2} />

      <div className="system-status-box">
        <h1 className="maintenance-title">PORTFOLIO REDESIGN IN PROGRESS</h1>

        <div className="status-log">
          <div className="log-entry">&gt; ARCHIVING LEGACY SYSTEMS... [DONE]</div>
          <div className="log-entry">&gt; CONSTRUCTING V2.0 ARCHITECTURE... [IN PROGRESS]</div>
          <div className="log-entry">&gt; ESTIMATED COMPLETION... [TBD]</div>
        </div>

        <div className="manual-override-msg">
          <p>I am currently building a completely new version of my portfolio here.</p>
          <p>Please visit my active portfolio via the link below.</p>
        </div>

        <a href={redirectUrl} className="backup-link">
          VISIT ACTIVE PORTFOLIO
        </a>
      </div>
    </div>
  );
};

export default MaintainanceScreen;
